import { observer } from 'mobx-react'
import './index.scss'
import { ReactComponent as Package } from '../../assets/track/Group 48095705.svg'

const ErrorBlock = observer(() => {
  const content = {
    title: 'Щось пішло не так',
    text: `Але ми вже працюємо над цим. Повторіть спробу через 5 хвилин.`,
    buttonTitle: 'Повторити',
  }
  return (
    <section className="error-block">
      <Package className="error-block__img" />
      <div
        className="error-block__title"
        dangerouslySetInnerHTML={{ __html: content.title }}
      ></div>
      <div
        className="error-block__text"
        dangerouslySetInnerHTML={{ __html: content.text }}
      ></div>
      <div className="button black" onClick={() => window.location.reload()}>
        {content.buttonTitle}
      </div>
    </section>
  )
})

export default ErrorBlock
